import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CopyOutlined } from '@ant-design/icons'
import { Typography, Row, Col, Button, Input } from 'antd'
import axios from 'axios'
import moment from 'moment'
import { dispatchAlert } from '../../Utilities/dispatchAlert'

const { Title, Paragraph, Text } = Typography

function SupportAccessComponent() {
	const dispatch = useDispatch()
	const { token } = useSelector(state => state)
	const [loading, setLoading] = useState(false)
	const [supportCode, setSupportCode] = useState('')
	const [expiresAt, setExpiresAt] = useState('')

	const copyToClipboard = text => {
		const textArea = document.createElement('textarea')
		textArea.value = text
		textArea.style.position = 'fixed'
		textArea.style.opacity = '0'
		document.body.appendChild(textArea)
		textArea.select()
		textArea.setSelectionRange(0, 99999)

		try {
			const successful = document.execCommand('copy')
			dispatch(
				dispatchAlert(
					true,
					successful ? 'success' : 'error',
					successful ? 'Support PIN copied to clipboard' : 'Failed to copy support code.'
				)
			)
		} catch (error) {
			dispatch(dispatchAlert(true, 'error', 'Failed to copy support code.'))
		}

		document.body.removeChild(textArea)
	}

	const generateCode = async () => {
		try {
			setLoading(true)
			dispatch(dispatchAlert(true, 'loading'))

			const url = `${process.env.REACT_APP_ENITURE_API_URL}/generate_support_token`
			const config = {
				headers: {
					authorization: `Bearer ${token}`,
				},
			}
			const { data } = await axios.post(url, {}, config)

			const isSuccess = data?.severity === 'SUCCESS'
			const code = isSuccess ? data?.token || '' : ''
			const expires = isSuccess && data?.expiry
				? moment(data.expiry, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY HH:mm:ss')
				: ''

			setSupportCode(code)
			setExpiresAt(expires)

			dispatch(
				dispatchAlert(
					true,
					isSuccess ? 'success' : 'error',
					data?.message || (isSuccess ? 'Support PIN generated.' : 'Unable to generate a support code.')
				)
			)
		} catch (err) {
			dispatch(dispatchAlert(false, null))
		} finally {
			setLoading(false)
		}
	}

	return (
		<Row gutter={30} justify='center' className={'mb-3'}>
			<Col className='gutter-row' xs={24} sm={24} md={24} lg={18} xl={12}>
				<div className={'content-box box-shadow'} style={{ padding: '40px' }}>
					<Title className={'mt-0'} level={3}>
						Chat Support
					</Title>
					<Paragraph>
						Generate a Support PIN to share in Eniture Technology's chatbot for authentication purposes. The chatbot will inform you when it is required.
						
					</Paragraph>
					<Paragraph type='secondary'>
						Generating a new Support PIN invalidates the previous one.
					</Paragraph>

					<Button type='primary' loading={loading} onClick={generateCode}>
						Generate new support code
					</Button>

					{supportCode ? (
						<div
							style={{
								marginTop: 24,
								padding: 16,
								background: '#f5f5f5',
								borderRadius: 4,
							}}>
							<Text strong>Your support PIN</Text>
							<Row gutter={8} align='middle' style={{ marginTop: 8 }}>
								<Col flex='auto'>
									<Input readOnly value={supportCode} size='large' />
								</Col>
								<Col>
									<Button
										icon={<CopyOutlined />}
										onClick={() => copyToClipboard(supportCode)}>
										Copy Support PIN
									</Button>
								</Col>
							</Row>
							{expiresAt ? (
								<Paragraph
									type='secondary'
									style={{ marginTop: 8, marginBottom: 0 }}>
									Expires: {expiresAt}
								</Paragraph>
							) : null}
						</div>
					) : null}
				</div>
			</Col>
		</Row>
	)
}

export default SupportAccessComponent
